/**** mgt.Vehicle_Task */
import moment       from 'moment';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const dowToDay: { [key: string]: string } = {
  '0': 'Воскресенье',
  '1': 'Понедельник',
  '2': 'Вторник',
  '3': 'Среда',
  '4': 'Четверг',
  '5': 'Пятница',
  '6': 'Суббота',
};

const config = {
  schema: 'mgt',
  table: 'Vehicle_Task',
  title: 'Назначение ТС на маршрут',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    raspvars: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'RaspVariants',
      index: 'id',
      fields: ['id', 'route_short_name', 'dow', 'startdate', 'enddate', 'srv_id'],
      customsql: `SELECT vr.id, rt.route_short_name,vr.dow, vr.startdate, vr.enddate, vr.srv_id
                  FROM mgt."RaspVariants" vr
                  INNER JOIN mgt."Routes" rt ON rt.route_id=vr.route_id`,
      format: (elem: any) =>
        `${elem['route_short_name']} - ${dowToDay[elem['dow'] + ''] ||
          'Любой день'} (${ elem['startdate'] ? moment(elem['startdate']).format('DD.MM.YYYY') : '?' }-${ elem['enddate'] ? moment(elem['enddate']).format('DD.MM.YYYY') : '?' }, ${elem['srv_id']})`,
      autocomplete: true,
    },
    vehicle: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Vehicle',
      index: 'vehicle_id',
      fields: ['depot_number'],
      format: (elem: any) => elem['depot_number'],
      autocomplete: true,
    },
    driver: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Driver',
      index: 'driver_id',
      fields: ['last_name', 'first_name', 'middle_name'],
      format: (elem: any) =>
        `${elem['last_name'] || ''} ${elem['first_name'] || ''} ${elem[
          'middle_name'
        ] || ''}`,
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'date',
      title: 'Дата',
      type: 'date',
      required: true,
    },
    {
      name: 'RaspVariant_id',
      title: 'Вариант расписания',
      type: 'number',
      required: true,
      connection: 'raspvars',
    },
    {
      name: 'graph',
      title: 'Номер выхода',
      type: 'connectionlist',
      required: true,
      filterSql: (row: any) => {
        return `SELECT DISTINCT graph FROM mgt."RaspTime" WHERE "RaspVariant_id"=${row['RaspVariant_id']} ORDER BY graph`
      },
      convert: (elem: any) => {
        return { key: elem['graph'], value: elem['graph'] };
      }
    },
    {
      name: 'smena',
      title: 'Номер смены',
      type: 'connectionlist',
      required: true,
      filterSql: (row: any) => {
        return `SELECT DISTINCT smena FROM mgt."RaspTime" WHERE "RaspVariant_id"=${row['RaspVariant_id']} ORDER BY smena`
      },
      convert: (elem: any) => {
        return { key: elem['smena'], value: elem['smena'] };
      }
    },
    {
      name: 'vehicle_id',
      title: 'Транспортное средство',
      type: 'number',
      required: true,
      connection: 'vehicle',
    },
    {
      name: 'driver_id',
      title: 'Водитель',
      type: 'number',
      required: true,
      connection: 'driver',
    },
  ],
  newTemplate: {
    id: null,
    date: null,
    RaspVariant_id: null,
    graph: null,
    smena: null,
    vehicle_id: null,
    driver_id: null,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'date',
        field: 'date',
        type: 'date'
      },
      {
        title: 'route_number',
        field: 'route_number',
        type: 'string'
      },
      {
        title: 'grafic',
        field: 'grafic',
        type: 'number'
      },
      {
        title: 'depot_number',
        field: 'depot_number',
        type: 'number'
      },
      {
        title: 'start_time',
        field: 'start_time',
        type: 'start_time'
      },
      {
        title: 'end_time',
        field: 'end_time',
        type: 'end_time'
      },
    ],
    example: `24.08.2022;15005;1;6915;04:48;16:22`,
    canWithoutCsvHeader: true,
    insertProcedure: 'handbooks.incert_into_veh_task_or_replace_veh'
  },
  export: {
    fields: [
      {
        name: 'date',
        title: 'Дата',
        type: 'date'
      },
      {
        name:             'route_name',
        title:            'Маршрут',
        connection:       'routes',
        connectionKey:    'stop_id',
        connectionGetField: 'route_short_name',
      },
      {
        name: 'vehicle_type',
        title: 'Тип ТС',
        connection: 'vehicle_type'
      },
      {
        name: 'RaspVariant_id',
        title: 'Вариант расписания',
        connection: 'raspvar',
        connectionGetField: 'raspvar',
      },
      {
        name: 'graph',
        title: 'Номер выхода',
      },
      {
        name: 'smena',
        title: 'Номер смены',
      },
      {
        name: 'vehicle_id',
        title: 'Транспортное средство',
        connectionField: 'vehicle_id',
      },
      {
        name: 'driver_id',
        title: 'Водитель',
        format: {
          fields: ['last_name', 'first_name', 'middle_name'],
          template: '%1 %2 %3'
        }
      }
    ],
    connections: {
      raspvar: {
        index: 'RaspVariant_id',
        customsql: 
          `
            SELECT
                r.route_short_name ||  ' - ' ||
                CASE
                    WHEN rv.dow IS NULL THEN 'Любой день'
                    WHEN rv.dow = 0 THEN 'воскресенье'
                    WHEN rv.dow = 1 THEN 'понедельник'
                    WHEN rv.dow = 2 THEN 'вторник'
                    WHEN rv.dow = 3 THEN 'среда'
                    WHEN rv.dow = 4 THEN 'четверг'
                    WHEN rv.dow = 5 THEN 'пятница'
                    WHEN rv.dow = 6 THEN 'суббота'
                    ELSE 'неизвестно'
                end ||  ' (' ||
                COALESCE(rv.startdate::date::text, '?') ||  ' - ' ||  COALESCE(rv.enddate::date::text, '?') || ')'
                AS raspvar
            FROM
                mgt."Vehicle_Task" vt
            INNER JOIN 
              mgt."RaspTime" rt ON rt."RaspVariant_id" = vt."RaspVariant_id"
            INNER JOIN
                mgt."RaspVariants" rv ON vt."RaspVariant_id" = rv.id
            INNER JOIN
                mgt."Routes" r ON rv.route_id = r.route_id
            INNER JOIN
                mgt."Vehicle" v ON vt.vehicle_id = v.vehicle_id
            INNER JOIN
                mgt."Driver" d ON vt.driver_id = d.driver_id
          `
      }
    },
    routes:   {
        index: 'stop_id',
        customsql:
          `SELECT
              r.route_short_name,
          FROM
              mgt."RaspTime" rt
          INNER JOIN
              mgt."Stops" s on rt.stop_id = s.stop_id
          INNER JOIN
              mgt."RaspVariants" rv ON rt."RaspVariant_id" = rv.id
          INNER JOIN
              mgt."Routes" r ON rv.route_id = r.route_id`
      },
      vehicle_type: {
        index: 'stop_id',
        customsql:
          `
            SELECT
                v.route_type
            FROM
                mgt."RaspTime" rt
            INNER JOIN
                mgt."Stops" s on rt.stop_id = s.stop_id
            INNER JOIN
                mgt."RaspVariants" rv ON rt."RaspVariant_id" = rv.id
            INNER JOIN
                mgt."Routes" r ON rv.route_id = r.route_id
            INNER JOIN
                mgt."Vehicle_Task" vt ON rv.id = vt."RaspVariant_id"
            INNER JOIN
                mgt."Vehicle" v ON vt.vehicle_id = v.vehicle_id
          `,
      },
  }
};

export default config;